import React from 'react';

export const GlobalIframe = ({ link, title, className }) => {
    const videoId = link ? link.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1] : '';
    const youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`;

    return (
        <iframe
            className={className}
            src={youtubeEmbedLink}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
        ></iframe>
    );
};
